import React, { useState } from "react";
import casestudy from "../../assets/FlipImages/1.png";
import {
  TextField,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import global from "../../assets/images/blogs/Global-Expansion-1.png";
import { Helmet } from "react-helmet";
import regulatoryimg from "../../assets/images/blogs/Regulatory-img.png";

const StateCPASociety = () => {
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [saveInfo, setSaveInfo] = useState(false);
  const [comments, setComments] = useState([]);

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleWebsiteChange = (event) => {
    setWebsite(event.target.value);
  };

  const handleSaveInfoChange = (event) => {
    setSaveInfo(event.target.checked);
  };

  const handleCommentSubmit = () => {
    if (comment.trim() && name.trim() && email.trim()) {
      setComments([...comments, { comment, name, email, website }]);
      setComment("");
      setName("");
      setEmail("");
      setWebsite("");
      setSaveInfo(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          State CPA Society Initiatives and 2025 Regulatory Updates | CPA
          Licensure Reforms{" "}
        </title>
        <meta
          name="description"
          content="Discover how state CPA societies and regulatory boards are transforming licensure requirements in 2025. Learn about key reforms, mobility provisions, and CPE updates."
        />
        <meta
          name="keywords"
          content="CPA licensure reforms 2025, State CPA society initiatives, CPA mobility law updates, CPA licensing changes by state, CPA licensure alternative pathways"
        />
      </Helmet>

      <style jsx>{`
        h4 {
          font-size: 18px;
        }
        h3 {
          font-size: 28px;
        }
        span {
          font-size: 16px;
        }
        p {
          font-size: 16px;
        }
        li {
          font-size: 16px;
          font-weight: 500;
        }
        .mainCard {
          height: 20rem;
        }
        .circle {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          overflow: hidden;
        }
        i {
          color: #072f5f;
        }
        ul {
          padding-left: 17px;
        }
        @media (max-width: 574px) {
          .mTop {
            margin-top: 30px;
          }
          p {
            font-size: 18px;
          }
          .img-fluid {
            min-height: 100px;
          }
          .container-fluid {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        @media (min-width: 992px) {
          /* for banner image */
          .bmTop {
            margin-top: 130px;
          }
        }
        @media (max-width: 574px) {
          .banner-image {
            margin-top: 70px; /* Adjust this value for mobile view */
          }
        }
      `}</style>

      <section className="">
        <div
          className="d-flex justify-content-center align-items-center banner-image"
          style={{
            background: `url(${casestudy}) no-repeat center`,
            backgroundSize: "cover",
            height: "200px",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3
              className="text-white text-uppercase text-center"
              style={{ fontWeight: "bold", marginTop: "10px" }}
            >
              State CPA Society Initiatives and Regulatory Roundups
            </h3>
          </div>
        </div>
        <div className="container-fluid">
          <div
            className="d-flex row justify-content-center align-items-start"
            style={{ gap: "2rem" }}
          >
            <div
              className="col-lg-8 mt-50 mb-50 border shadow"
              style={{ padding: "2rem" }}
            >
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div>
                  <div
                    style={{
                      background: "#072f5f",
                      display: "inline",
                      width: "fit-content",
                      padding: "0.2rem 1rem 0.2rem 1rem",
                    }}
                  >
                    <small
                      className="text-uppercase text-white"
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      Introduction
                    </small>
                  </div>
                  <div className="mt-15">
                    <small
                      className="text-uppercase text-black mb-5"
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      State CPA Society Initiatives and Regulatory Roundups:
                      Navigating the Dynamic Environment of Professional
                      Accounting Standards in United States Jurisdictions
                    </small>
                  </div>
                  <div className="mt-15">
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      The accounting profession is undergoing a historic
                      transformation as state CPA societies and regulatory
                      boards throughout the United States launch innovative
                      programs to meet the persistent talent shortage and
                      modernize licensure requirements. From Massachusetts to
                      California, regulatory agencies are redefining the future
                      of CPA certification by establishing innovative pathways
                      and revised professional standards.
                    </p>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Historic Reforms to CPA Licensure Requirements
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      The greatest progress in 2025 is the widespread use of
                      non-traditional routes to CPA licensure, stretching beyond
                      the traditional 150-hour educational requirement. States
                      have implemented widespread reforms aimed at increasing
                      access to the profession while maintaining high
                      professional standards. The AICPA and NASBA have supported
                      model legislation that creates new paths for CPA
                      candidates, including safe harbor provisions for
                      professionals licensed under different education,
                      experience, and examination requirements.
                    </p>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Texas has also led the way in this change, as Governor
                      Greg Abbott signed the bill on May 8, 2025, which
                      establishes additional avenues to CPA licensure and
                      includes automatic mobility provisions. The Texas bill was
                      passed unanimously by both the state house and senate,
                      with the new law going into effect on September 1, 2025.
                      Likewise, Tennessee Governor Bill Lee signed HB1330 on May
                      21, 2025, establishing similar pathways and mobility
                      improvements for accounting professionals.{" "}
                    </p>

                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        State-Specific Regulatory Updates and Professional
                        Development Initiatives
                      </span>
                    </div>

                    <li>
                      California continues to be a leader in regulatory
                      evolution by embracing new continuing education standards
                      and compliance rules for CPAs licensed to practice. The
                      California Board of Accountancy has implemented new
                      regulations that require adherence to state CPA society
                      standards but also provide exemptions for certain
                      continuing education during renewal cycles
                    </li>
                    <li>
                      Virginia's CPA society announced an ambitious schedule of
                      professional development activities for 2025, featuring
                      the 55th Annual Virginia Accounting & Auditing Conference
                      on September 29-30, 2025, in Roanoke, and the Construction
                      Industry Virtual Conference with FICPA on October 9, 2025.
                      These efforts reflect state societies' dedication to
                      offering comprehensive continuing education events that
                      address changing industry needs.
                    </li>
                  </div>

                  <div className="mt-15">
                    <span
                      className="text-capitalize"
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: "#002249",
                      }}
                    >
                      Influence on Professional Practice and Career Growth
                    </span>
                  </div>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    Regulatory changes are opening new avenues for accounting
                    professionals while also assisting in filling critical
                    workforce gaps. State CPA society leaders across the country
                    have been aggressively promoting changes in licensure
                    requirements, recognizing the need to bring a diverse talent
                    pool into the profession. Provisions for automatic mobility
                    enable smoother practice by CPAs on a state-by-state basis,
                    thus complementing the increasingly integrated nature of
                    modern-day business operations.
                  </p>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    Florida's efforts at regulation have drawn significant
                    attention, as the state's deregulation initiatives have
                    sparked debate throughout the industry about balancing
                    accessibility with professionalism. More than a dozen states
                    have implemented legislation that softens CPA licensure
                    requirements, creating a patchwork of regulations that
                    accounting firms must navigate with caution.{" "}
                  </p>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Foreseeing the Future: Trends and Their Consequences
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      CPA Evolution 2025 is continuously redefining examination
                      requirements and professional standards, bringing profound
                      changes to examination dates and scoring processes that
                      affect candidates nationwide. State boards are undergoing
                      collaborative actions to ensure consistency while allowing
                      jurisdictional flexibility in the implementation process.
                    </p>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      These regulatory updates are more than mere administrative
                      adjustments; they embody a fundamental change in the
                      perception of accessibility, diversity, and professional
                      capability in the accounting profession. While state CPA
                      societies continue to reinvent and alter their programs,
                      there is a need for accounting professionals and
                      businesses to remain abreast of evolving requirements in
                      their jurisdictions.{" "}
                    </p>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      To address these developments, accounting professionals
                      and firms find it increasingly valuable to collaborate
                      with experienced advisors who understand the regulatory
                      landscape across multiple jurisdictions. State CPA society
                      activities in this dynamic setting require ongoing
                      monitoring of compliance requirements and professional
                      continuing education opportunities aligned with new
                      standards and expectations.{" "}
                    </p>
                  </div>

                  <img
                    src={regulatoryimg}
                    style={{
                      display: "block",
                      margin: "1rem auto",
                      width: "350px",
                      height: "270px",
                    }}
                  />

                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    Keep informed of emerging CPA regulatory trends and
                    continuing professional education opportunities by
                    monitoring state society announcements and seeking the
                    advice of experienced accounting professionals who
                    understand the implications of these changing standards.
                  </p>

                  <Box
                    mt="2rem"
                    p="2rem"
                    border="1px solid #ddd"
                    borderRadius="8px"
                  >
                    <Typography variant="h5" gutterBottom>
                      Leave a Comment
                    </Typography>
                    <TextField
                      label="Message"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={comment}
                      onChange={handleCommentChange}
                      margin="normal"
                    />
                    <Box display="flex" gap="1rem">
                      <TextField
                        label="Name"
                        variant="outlined"
                        fullWidth
                        value={name}
                        onChange={handleNameChange}
                        margin="normal"
                      />
                      <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value={email}
                        onChange={handleEmailChange}
                        margin="normal"
                      />
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={saveInfo}
                          onChange={handleSaveInfoChange}
                        />
                      }
                      label="Save my name, email, and website in this browser for the next time I comment."
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCommentSubmit}
                      style={{ backgroundColor: "rgb(0, 34, 73)" }}
                    >
                      Send Comment
                    </Button>
                  </Box>
                  <Box mt="2rem">
                    {comments.map((cmt, index) => (
                      <Box
                        key={index}
                        mt="1rem"
                        p="1rem"
                        border="1px solid #ddd"
                        borderRadius="8px"
                      >
                        <Typography variant="body1">{cmt.comment}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {cmt.name} - {cmt.email}
                          {cmt.website && ` - ${cmt.website}`}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StateCPASociety;
